import styled from 'styled-components';

type Props = {
  $isActive?: boolean;
};

export const NavigationOverlay = styled.div<Props>`
  background-color: rgba(0, 0, 0, 0.2);
  backface-visibility: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  height: 100vh;
  z-index: 101; // just above header
  opacity: 0;
  visibility: hidden;
  -webkit-backface-visibility: hidden;
  transition: opacity 800ms ease 0s, visibility 0s 800ms;

  ${({ $isActive }) =>
    $isActive &&
    `
      opacity: 1;
      visibility: visible;
      transition: opacity 200ms ease 0s, visibility 0s 0s;
    `}
`;
